/* ==========================================================================
   MODULE CADEAU DU PANIER LATERAL - My Jilbab Femme
   --------------------------------------------------------------------------
   Fichier : assets/mjf-panier-cadeau.js

   A charger depuis layout/theme.liquid, juste avant </body> :
     {{ 'mjf-panier-cadeau.js' | asset_url | script_tag }}

   Ce code ne doit PAS vivre dans le snippet : quand le panier lateral se
   recharge, son contenu est injecte en innerHTML, et un <script> insere de
   cette facon n'est jamais execute par le navigateur. Les ecouteurs sont
   donc poses une seule fois sur document : ils survivent a tous les
   rechargements du panier.
   ========================================================================== */

(function () {
  if (window.mjfCadeauPret) return;
  window.mjfCadeauPret = true;

  var PLAFOND = 300;

  /* -------------------------------------------------------------------
     Horizon 3.5 rend le panier a l'interieur de cart-items-component.
     Si ce composant utilise un shadow root, un evenement qui en sort est
     recible sur l'hote : e.target ne designe plus le bouton clique et
     e.target.closest ne trouve plus rien. On lit donc le chemin complet
     de l'evenement (composedPath), qui lui traverse les frontieres.
     ------------------------------------------------------------------- */
  function cible(e, selecteur) {
    var chemin = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < chemin.length; i++) {
      var n = chemin[i];
      if (n && n.nodeType === 1 && n.matches && n.matches(selecteur)) return n;
    }
    var t = e.target;
    return t && t.closest ? t.closest(selecteur) : null;
  }

  /* Remonte aussi a travers les hotes de shadow root, ce que closest seul
     ne sait pas faire. */
  function remonter(el, selecteur) {
    var n = el;
    while (n) {
      if (n.closest) {
        var trouve = n.closest(selecteur);
        if (trouve) return trouve;
      }
      var racineDom = n.getRootNode ? n.getRootNode() : null;
      n = racineDom && racineDom.host ? racineDom.host : null;
    }
    return null;
  }

  function racine(el) {
    return remonter(el, '[data-mjf-cadeau]');
  }

  function argent(centimes) {
    return '\u20AC' + (centimes / 100).toFixed(2).replace('.', ',');
  }

  function tuiles(r) {
    return Array.prototype.slice.call(r.querySelectorAll('[data-mjf-cadeau-tuile]'));
  }

  function selection(r) {
    return tuiles(r).filter(function (t) {
      return t.getAttribute('aria-pressed') === 'true';
    });
  }

  function erreur(r, texte) {
    var p = r.querySelector('[data-mjf-cadeau-erreur]');
    if (!p) return;
    p.textContent = texte || '';
    p.classList.toggle('is-cache', !texte);
  }

  /* Le champ garde toujours une ligne vide d'avance sous le curseur, et ne
     descend jamais sous sa hauteur de depart (2 lignes). */
  function grandir(ta) {
    var styles = window.getComputedStyle(ta);
    var ligne = parseFloat(styles.lineHeight) || 21;
    var plancher = parseFloat(styles.minHeight) || 60;

    ta.style.height = 'auto';

    var souhaitee = ta.scrollHeight + ligne;
    var finale = Math.max(plancher, Math.min(souhaitee, PLAFOND));

    ta.style.height = finale + 'px';
    ta.style.overflowY = souhaitee > PLAFOND ? 'auto' : 'hidden';
  }

  function majCompteur(r, ta) {
    var cpt = r.querySelector('[data-mjf-cadeau-compteur]');
    if (!cpt) return;
    var n = ta.value.length;
    var max = parseInt(r.dataset.max, 10) || 500;
    var seuil = parseInt(r.dataset.seuil, 10) || Math.round(max * 0.8);
    cpt.textContent = n + ' / ' + max;
    cpt.classList.toggle('is-visible', n >= seuil);
  }

  function majTotal(r) {
    var sel = selection(r);
    var total = 0;
    var carteSel = false;

    sel.forEach(function (t) {
      total += parseInt(t.dataset.prix, 10) || 0;
      if (t.dataset.role === 'carte') carteSel = true;
    });

    var btn = r.querySelector('[data-mjf-cadeau-ajouter]');
    if (btn) {
      btn.textContent = sel.length === 0
        ? r.dataset.libelleVide
        : r.dataset.libelleAjout + ' \u2014 ' + argent(total);
    }

    var zone = r.querySelector('[data-mjf-cadeau-message]');
    if (zone) {
      zone.classList.toggle('is-cache', !carteSel);
      if (carteSel) {
        var champ = zone.querySelector('[data-mjf-cadeau-champ]');
        if (champ) grandir(champ);
      }
    }
  }

  function rafraichir(r) {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'mjf-cadeau' } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    var section = remonter(r, '[data-section-id]');
    var id = section ? section.dataset.sectionId : null;

    if (!id) {
      window.location.reload();
      return;
    }

    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (res) {
        if (!res.ok) throw new Error('section');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neuf = doc.querySelector('[data-section-id="' + id + '"]') || doc.body.firstElementChild;
        if (neuf) {
          section.innerHTML = neuf.innerHTML;
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function ajouter(r) {
    var btn = r.querySelector('[data-mjf-cadeau-ajouter]');
    var sel = selection(r);
    if (!sel.length || !btn) return;

    var ta = r.querySelector('[data-mjf-cadeau-champ]');
    var manuscrit = r.querySelector('[data-mjf-cadeau-manuscrit]');
    var carteSel = sel.some(function (t) {
      return t.dataset.role === 'carte';
    });

    var message = '';
    if (carteSel) {
      if (manuscrit && manuscrit.checked) {
        message = r.dataset.texteManuscrit;
      } else {
        message = ta ? ta.value.trim() : '';
        if (!message) {
          erreur(r, r.dataset.texteMessageVide);
          if (ta) ta.focus();
          return;
        }
      }
    }

    erreur(r, '');

    var items = sel.map(function (t) {
      var ligne = { id: parseInt(t.dataset.variant, 10), quantity: 1 };
      if (t.dataset.role === 'carte' && message) {
        ligne.properties = {};
        ligne.properties[r.dataset.nomPropriete] = message;
      }
      return ligne;
    });

    btn.disabled = true;
    btn.textContent = r.dataset.libelleEnvoi;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('ajout');
        return res.json();
      })
      .then(function () {
        rafraichir(r);
      })
      .catch(function () {
        btn.disabled = false;
        majTotal(r);
        erreur(r, r.dataset.texteErreur);
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target) return;

    var toggle = cible(e, '[data-mjf-cadeau-toggle]');
    if (toggle) {
      var r1 = racine(toggle);
      if (!r1) return;
      var panneau = r1.querySelector('.mjf-cadeau__panneau');
      var ouvert = r1.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      if (panneau) panneau.classList.toggle('is-cache', !ouvert);
      if (ouvert) {
        majTotal(r1);
        setTimeout(function () {
          r1.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 60);
      }
      return;
    }

    var tuile = cible(e, '[data-mjf-cadeau-tuile]');
    if (tuile && !tuile.disabled) {
      var r2 = racine(tuile);
      if (!r2) return;
      var actif = tuile.getAttribute('aria-pressed') === 'true';
      tuile.setAttribute('aria-pressed', actif ? 'false' : 'true');
      tuile.classList.toggle('is-on', !actif);
      erreur(r2, '');
      majTotal(r2);
      return;
    }

    var ajout = cible(e, '[data-mjf-cadeau-ajouter]');
    if (ajout) {
      var r3 = racine(ajout);
      if (r3) ajouter(r3);
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target) return;
    var ta = cible(e, '[data-mjf-cadeau-champ]');
    if (!ta) return;
    var r = racine(ta);
    if (!r) return;

    var avant = ta.style.height;
    grandir(ta);
    majCompteur(r, ta);
    erreur(r, '');

    if (avant !== ta.style.height) {
      ta.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    var champ = cible(e, '[data-mjf-cadeau-manuscrit]');
    if (!champ) return;
    var r = racine(champ);
    if (!r) return;
    var ta = r.querySelector('[data-mjf-cadeau-champ]');
    if (!ta) return;

    var coche = champ.querySelector('input[type="checkbox"]') || e.target;
    ta.disabled = coche.checked;
    if (coche.checked) {
      ta.value = '';
      majCompteur(r, ta);
    }
    grandir(ta);
    erreur(r, '');
  });
})();